import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-prompt',
  templateUrl: './login-prompt.component.html',
  styleUrls: ['./login-prompt.component.scss']
})
export class LoginPromptComponent {

  constructor(
    public dialogRef: MatDialogRef<LoginPromptComponent>,
    private router: Router
  ) { }

  public onLoginClick(): void {
    this.dialogRef.close();
    this.router.navigate(['/home/auth/login']);
  }

  public onCancelClick(): void {
    this.dialogRef.close();
  }

}
